import {ALL_PLANS, FREE_PLAN} from '../constants/plans'

export const getPlanByPriceId = (priceId: string) => {
  const plan = ALL_PLANS.find(x => x.priceId === priceId)
  return plan ?? FREE_PLAN
}
